<template>
    <div>
      <div class="form-group registration">
        <Pincode @pinready="setPin" />
        <input
            type="hidden"
            id="confirmPhone"
            name="confirmPhone"
            :value="pin"
            required="required"
        />
      </div>
    </div>
</template>

<script>
import I18n from '../i18n';
import Pincode from "../pincode.vue";

export default {
    components: {Pincode, I18n},
    data: function () {
        return {
            pin: null,
            version: 25
        }
    },
    methods: {
      setPin(value) {
        this.pin = value;
      }
    }
}
</script>

<style scoped>

</style>
